<template>
	<div :style="{ width: `${pWidth}px` }">
		<img alt="" class="relative w-full" src="images/1x_images/cell-body.png" srcset="images/2x_images/cell-body.png 2x" ref="part1El" />
		<img alt="" class="absolute w-[50%] top-[27%] left-[26%]" src="images/1x_images/cell-middle.png" srcset="images/2x_images/cell-middle.png 2x" ref="part2El" />
	</div>
</template>

<script>
/* eslint-disable */
import gsap from "gsap";

export default {
	props: {
		pWidth: 0,
	},
	data() {
		return {
			points: 4,
			bubbles: 1,
			bubblePosition: [{ top: 0, left: 0 }],
			speed: 0,
			location: 250,
			radius: 230,
			support: 28,
			range: 15,
			bubbleCoordsText: [],
			p5lib: "",
			noiseR: [],
			noiseS: [],
			noiseStep: 1,
			running: false,
			time: 0,
			stopped: false,
			tween: null,
		};
	},
	methods: {
		init() {
			// this.main();
			this.bigCircleHover();
		},
		bigCircleHover() {
			// return;
			this.tween = gsap.to(this.$refs.part1El, {
				force3D: true,
				// x: "random(-15,15)",
				y: "random(-15,15)",
				duration: 2,
				ease: "none",
				onComplete: () => this.bigCircleHover(),
			});
		},
		start() {
			console.log("bubble1 start");
			this.stopped = false;
			this.$nextTick(() => {
				this.init();
			});
		},
		stop() {
			// console.log("bubble1 stop");
			if (this.tween) {
				this.tween.kill();
			}
			this.stopped = true;
		},
	},
	mounted() {
		// this.init();
	},
};
</script>

<style scoped>
.bubble_border {
	stroke: darkgray;
	stroke-width: 2;
	opacity: 0.2;
}
</style>
